export const CloseIcon = ({ customClass }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={customClass}
  >
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
      fill="#D1D1D1"
    />
    <path
      d="M17.2167 16L21.8334 20.6167V21.8334H20.6167L16 17.2167L11.3834 21.8334H10.1667V20.6167L14.7834 16L10.1667 11.3834V10.1667H11.3834L16 14.7834L20.6167 10.1667H21.8334V11.3834L17.2167 16Z"
      fill="#121212"
    />
  </svg>
);
